<template>
  <div class="index">
    <div class="allcontainer">
      <div class="banner"></div>


      <!--编者按-视频-->
      <div class="clear"></div>
      <div class="nav_1">
        <div class="nav_1left">
          <dl>
            <dt>编者按</dt>
            <dd>{{postData.hotsub.info}}</dd>
          </dl>
        </div>


        <div class="nav_1right" @click="openVideo(postData.hotsub.video,1)">
          <div class="icon_1"><img src="../assets/shipin-tit.png"/></div>
          <div class="playerbox"><i></i><img :src="checkimg(postData.hotsub.logo)"/></div>
        </div>
        <div class="clear"></div>
      </div>


      <!--精选留言-->
      <div class="clear"></div>
      <div class="nav_2">
        <div class="nav_2left">
          <div class="icon_1"><img src="../assets/jingxuanliuyan-tit.png"/></div>
          <div class="message_box">
            <ul>
              <li v-for="(res , index) in messagelist" :key="index" ><span>[昵称：{{ res.username }}]</span>{{ res.content }}</li>
            </ul>
          </div>
          <div class="clear"></div>
        </div>
        <div class="nav_2right"><img src="../assets/wechat.jpg"/>
          <p>请使用手机扫码登录后向革命先烈献花留言，致敬英烈。</p></div>
        <div class="clear"></div>
      </div>


      <!--短视频作品展-->
      <div class="clear"></div>
      <div class="icon_1" v-show="postData.dsp.length > 0"><img src="../assets/zuopinzhan-tit.png"/></div>
      <div class="nav_3" v-show="postData.dsp.length > 0">
        <div class="p_left"></div>
        <div class="p_right"></div>
        <swiper :modules="modules"  :slides-per-view="4" :slides-per-group="4"   :space-between="0"
                :navigation="true"
                :autoplay="{
                  delay: 2500,
                  disableOnInteraction: false
                }"
                class="swiper p_box">
          <swiper-slide v-for="(res , index) in postData.dsp" :key="index">
            <dl><a @click="openVideo(res.video,2)"><i></i><img :src="checkimg(res.logo)" /></a></dl>
          </swiper-slide>
        </swiper>
        <div class="clear"></div>
      </div>


      <!--手抄报作品展-->
      <div class="clear"></div>
      <div class="icon_1" v-show="postData.scb.length > 0"><img src="../assets/shouchaobao-tit.png"/></div>
      <div class="nav_4" v-show="postData.scb.length > 0">
        <ul class="nav4_imgbox">
          <li v-for="(res , index) in postData.scb" :key="index"><a @click="OpenImg(res.logo)"><img :src="checkimg(res.logo)" /></a></li>
          <div class="clear"></div>
        </ul>
        <div class="clear"></div>
      </div>


      <!--新闻资讯-->
      <div class="clear"></div>
      <div class="icon_1"><img src="../assets/xinwen-tit.png"/></div>
      <div class="nav_5">
        <div class="nav_5left">
          <div class="n5box_img">
            <ul>
              <swiper class="swiper"
                      :modules="modules"
                      :autoplay="{
                        delay: 2500,
                        disableOnInteraction: false
                      }"
                      navigation
                      :pagination="{ clickable: true }">
                <swiper-slide v-for="(res , index) in postData.newshot" :key="index">
                  <li><a :href="checkurl(res.link)"><img :src="checkimg(res.logo)" /><p>{{ res.title }}</p></a></li>
                </swiper-slide>
              </swiper>
            </ul>
          </div>
          <div class="clear"></div>
        </div>
        <div class="nav_5right">
          <dl v-for="(res , index) in postData.newslist" :key="index">
            <a :href="checkurl(res.link)">
              <dt>{{ res.title }}</dt>
              <dd>{{ res.info }}</dd>
            </a>
          </dl>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </div>
    <!--专题脚-->
    <div class="clear"></div>
    <div class="bottombg"></div>

    <van-popup v-model:show="videoplay" @closed="closevideo()">
      <div class="showsVideos" :class="{'videopaly':playSta == 1,'videopalys': playSta == 2}">
        <video controls="controls" autoplay="autoplay" v-if="videoplay">
          <source :src="videoUrl" type="video/mp4">
        </video>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { Pagination, Navigation, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import Axios from 'axios'
import { showImagePreview } from 'vant';
export default {
  name: "home",
  data() {
    return {
      modules: [Pagination, Navigation, Autoplay],
      showVideo: false,
      videoUrl: '',
      videoplay: false,
      postData:{
        dsp:[],
        hotsub:{
          info:'',
          logo:'',
          video:''
        },
        newshot:[],
        newslist:[],
        scb:[]
      },
      mymessage:{
        username:'',
        mes:''
      },
      messagelist:[],
      showmessage:false,
      playSta:''
    }
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getdata(){
      // let listData = require('../assets/data/newlist.json')
      // console.log(listData)
      // this.postData.hotsub = listData?.info[0];
      // this.postData.dsp = listData?.dsp
      // this.postData.scb = listData?.scb
      // this.postData.newshot = listData?.newshot
      // this.postData.newslist = listData?.newslist


      Axios('https://qmjyl.kunming.cn/2023qmjyl/newlist.json').then((res) =>{
        let listData = res.data;
        this.postData.hotsub = listData?.info[0];
        this.postData.dsp = listData?.dsp
        this.postData.scb = listData?.scb
        this.postData.newshot = listData?.newshot
        this.postData.newslist = listData?.newslist
      })
      // 回复消息数据源
      Axios('https://qmjyl.kunming.cn/2023qmjyl/list.json').then((res) =>{
        let messageData = res.data;
        // let messageData = require('../assets/data/list.json')
        // console.log(messageData)
        this.messagelist = messageData;
      })
      // let messageData = require('../assets/data/list.json')
      // this.messagelist = messageData;
    },
    openVideo(url,playnum) {
      if(url){
        this.videoUrl = url;
        this.videoplay = true;
        this.playSta = playnum
      }
    },
    closevideo(){
      this.videoUrl = '';
      this.videoplay = false;
    },
    swiperTo(num) {

    },
    checkimg(url){
      if(url.indexOf('png') != -1){
        let name = url.substr(url.lastIndexOf(".") + -7,7)
        return 'https://qmjyl.kunming.cn/2023qmjyl/images/'+name+'.png'
      }
      else {
        let name = url.substr(url.lastIndexOf(".") + -7,7)
        return 'https://qmjyl.kunming.cn/2023qmjyl/images/'+name+'.jpg'
      }
    },
    checkurl(url){
      if(url.indexOf('https://www.kunming.cn/') != -1){
        return url
      }
      else {
        let string = 'https://www.kunming.cn'+url+'';
        return string
      }
    },
    OpenImg(val){
      let imgstring = this.checkimg(val)
      console.log(imgstring)
      showImagePreview({
        images: [imgstring],
        closeable: true,
      });
    }
  },
  components: {
    Swiper,
    SwiperSlide
  }
}
</script>

<style scoped>

</style>
